import { render, staticRenderFns } from "./V2ProductCard.vue?vue&type=template&id=128730fd&scoped=true&"
import script from "./V2ProductCard.vue?vue&type=script&lang=js&"
export * from "./V2ProductCard.vue?vue&type=script&lang=js&"
import style0 from "./V2ProductCard.vue?vue&type=style&index=0&id=128730fd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "128730fd",
  null
  
)

export default component.exports